import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import HostContracts from "@/components/contracts/HostContracts";

export default function Contracts() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-[var(--ff-text-dim)] font-mono-ui text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-24" data-testid="contracts-page">
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-none mb-8">MY CONTRACTS.</h1>
      <HostContracts />
    </div>
  );
}
